// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2OQyg","label":"Labeled_label__3vC_Z","divider":"Labeled_divider__3XfMA"};